<template>
  <div class="main dl_gray_color_bg">
    <mt-header :title="$t('快讯')" class="dl_header_white dl_line_bottom" fixed>
      <mt-button icon="back" slot="left" @click="goback"></mt-button>
    </mt-header>
    <div class="page-loadmore-wrapper" ref="wrapper" :style="{ height: wrapperHeight + 'px' }">
      <mt-loadmore :top-method="loadTop" @top-status-change="handleTopChange":bottom-method="loadBottom"@bottom-status-change="handleBottomChange" :bottom-all-loaded="allLoaded" ref="loadmore" :auto-fill="false">
        <div class="container">
          <div class="zixun" v-for="item in noticeList" >
            <div class="time"><span></span>{{item.create_time | parseTime}}</div>
            <div class="title"><a :href="item.visit_url">{{item.post_title}}</a></div>
            <div class="excerpt">{{item.post_content}}</div>
            <div class="font12 resource dianzan">
              <a @click="doshare(item.post_title,item.post_content,item.create_time,item.post_like,item.post_cai)" class="like share fr" href="javascript:;"><label>{{$t('分享')}}</label></a>
              <a @click="addcai(item.id)" class="like fall-h fr" href="javascript:;"><label>{{$t('利空')}} {{item.post_cai}}</label></a><i class="addition green" style="display: none;"></i>
              <a @click="addlike(item.id)" class="like rose-h fr" href="javascript:;"><label>{{$t('利好')}} {{item.post_like}}</label></a><i class="addition red" style="display: none;"></i>
              <div class="clear"></div>
            </div>
          </div>
        </div>
        <div slot="top" class="mint-loadmore-top">
          <span v-show="topStatus !== 'loading'" :class="{ 'is-rotate': topStatus === 'drop' }">↓</span>
          <span v-show="topStatus === 'loading'">
            <mt-spinner type="snake"></mt-spinner>{{$t('正在刷新...')}}
          </span>
        </div>
        <div slot="bottom" class="mint-loadmore-bottom">
          <span v-show="bottomStatus !== 'loading'" :class="{ 'is-rotate': bottomStatus === 'drop' }"></span>
          <span v-show="bottomStatus === 'loading'">
            <mt-spinner type="snake"></mt-spinner>{{$t('正在加载...')}}
          </span>
        </div>
      </mt-loadmore>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { httpCloudLists, httpNoticeLists, httpNoticeAddlike, httpNoticeSublike, httpNoticeAddcai, httpNoticeSubcai } from "@/api/index";
import { parseTime,share,sharezixun } from "@/utils/index";

export default {
  name: "Zixun",
  components: { Toast },
  data() {
    return {
      noticeList: {},
      uid:666,
      pageNo:1,
      array_pages:'',
      allLoaded: false,
      bottomStatus: '',
      wrapperHeight: 0,
      topStatus: '',
      translate: 0,
      moveTranslate: 0
    };
  },
  activated(){
    this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top;
    this.noticeLists(1);
    this.pageNo = 1;
  },
  methods:{
    handleBottomChange(status) {
          this.bottomStatus = status;
      },
    loadBottom() {
      var _this = this
         setTimeout(() => {
          if (_this.pageNo*10 <= _this.array_pages) {
            _this.pageNo++;
            _this.noticeLists(_this.pageNo)
          } else {
            _this.allLoaded = true;
          }
          _this.$refs.loadmore.onBottomLoaded();
         }, 1500);
    },

    handleTopChange(status) {
      this.moveTranslate = 1;
      this.topStatus = status;
    },

    translateChange(translate) {
    const translateNum = +translate;
    this.translate = translateNum.toFixed(2);
    this.moveTranslate = (1 + translateNum / 70).toFixed(2);
    },

    loadTop() {
      var _this = this
      setTimeout(() => {
        _this.noticeLists(1);
        _this.allLoaded = false;
        _this.pageNo = 1;
        _this.$refs.loadmore.onTopLoaded();
      }, 1500);
    },
    noticeLists: function(pageNo) {
      httpNoticeLists({ type: 4 ,limit_start:0,limit_num:pageNo*10})
        .then(res => {
          this.noticeList =[];
          this.array_pages = res.data.count;
          this.noticeList = res.data.list;
        })
        .catch(() => {});
    },
    shareartile: function(pageNo) {
      httpNoticeLists({ type: 4 ,limit_start:0,limit_num:pageNo*10})
        .then(res => {

        })
        .catch(() => {});
    },
    doshare(desc,content,date,lihao,likong){
        var p={
          title:desc,
          content:content,
          date:date,
          lihao:lihao,
          likong:likong
        }
        console.log(p);
        sharezixun(JSON.stringify(p));
    },
    addlike: function(id) {
      httpNoticeAddlike({ uid: this.uid ,id:id})
        .then(res => {
          for (var i = 0; i <this.noticeList.length; i++){
            if (this.noticeList[i].id == id) {
              this.noticeList[i].post_like = parseInt(parseInt(this.noticeList[i].post_like) + 1);
            }
          }
        })
        .catch(() => {});
    },
    addcai: function(id) {
      httpNoticeAddcai({ uid: this.uid ,id:id})
        .then(res => {
          for (var i = 0; i <this.noticeList.length; i++){
            if (this.noticeList[i].id == id) {
              this.noticeList[i].post_cai = parseInt(parseInt(this.noticeList[i].post_cai) + 1);
            }
          }
        })
        .catch(() => {});
    },
    goback: function() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },

  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.main {
  padding-top: 40px;
  height: 100%;
  box-sizing: border-box;
  background-color: #fff;
  z-index: 10;
}
.container {
  padding: 10px 10%;
}
.zixun{
  position: relative;
  color: #333;
  border-left: 2px solid #e5e5e5;
  padding: 10px 0;
  a{
    color: #333;
    font-weight:500;
  }
  div{
    padding: 0 10px;
    margin: 0 0 10px 0;
    color: #a9afc8;
  }
  .time{
    color: #333;
    span{
      position: absolute;
      left: -6px;
      top: 16px;
      display: inline-block;
      height: 10px;
      width: 10px;
      background-color: #1296db;
      border-radius: 50%;
    }

  }
  .dianzan{
    font-size: 14px;
  }

  .fr{
    float: right;
  }
  a.like {
    padding: 5px 4px 3px 40px;
    color: #999;
    border: #FFF 1px solid;
    display: inline-block;
    background-size: 16px 10px;
    background-position: 18px 9px;
  }
  .clear{
    clear: both;
    height: 0;
  }
  .fall {
    background: url(../../assets/img/fall.png) no-repeat;
  }
  .fall-h {
    background: url(../../assets/img/fall-h.png) no-repeat;
  }
  .rose{
    background: url(../../assets/img/rose.png) no-repeat;
  }
  .rose-h {
    background: url(../../assets/img/rose-h.png) no-repeat;
  }
  a.share{
    background: url(../../assets/img/share.png) no-repeat;
    background-size: 14px 14px;
    background-position: 20px 7px;
  }
}
</style>

